import type { AxiosResponse } from 'axios';
import axiosInstance from '../axiosInstance';
import { BaseService } from './baseService';

class SurveySubmissionsService extends BaseService<
	SurveySubmission,
	'surveySubmissionID',
	'surveySubmissions'
> {
	constructor() {
		super('surveySubmissionID', 'surveySubmission', 'surveySubmissions');
	}

	async getSubmissionsBySurveyID(
		surveyID: number,
		queryParams?: Record<string, string>,
	) {
		const response: AxiosResponse<
			TavoittajaApiArrayResponse<'surveySubmissions', SurveySubmission[]>
		> = await axiosInstance.get(
			`/app/surveys/${surveyID}/surveySubmissions`,
			{
				params: queryParams,
			},
		);

		return response.data;
	}

	async export(
		surveyID: number,
		options: { filters: string; columnsToExport: string[]; language: Lang },
	) {
		return axiosInstance.post(
			`/app/surveys/${surveyID}/surveySubmissions/export${options.filters}`,
			{
				language: options.language,
				columnsToExport: options.columnsToExport,
			},
			{
				responseType: 'blob',
			},
		);
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new SurveySubmissionsService();
